module.exports = __webpack_public_path__ + "static/img/Min-chang Cheng.jpg";